import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { BOLOCR, BolOcrAuditService } from '../../bol-ocr-audit.service';

@Component({
  selector: 'lohi-bol-ocr-audit-order',
  templateUrl: './bol-ocr-audit-order.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BolOcrAuditOrderComponent implements OnDestroy {
  private BOL_NUMBER_LOCATION_TYPE = 'bol_location';
  private DATE_LOCATION_TYPE = 'date_location';
  private LOAD_WEIGHT_LOCATION_TYPE = 'load_weight_location';
  private PURCHASE_ORDER_LOCATION_TYPE = 'purchase_order_location';

  public orderBOLOCR$: Observable<BOLOCR>;
  public highlightLocationType: string;

  private orderSubscription: Subscription;

  public bolNumberFound = false;
  public poNumberFound = false;
  public loadWeightFound = false;
  public dateFound = false;

  @ViewChild('bolImg') public set bolImg(bolImg: ElementRef<HTMLImageElement>) {
    if (bolImg) {
      bolImg.nativeElement.onload = (ev) => this.cd.markForCheck(); // tell Angular the image has loaded so it can size the div
    }
  }

  constructor(private bolocrService: BolOcrAuditService, private cd: ChangeDetectorRef) {
    this.orderBOLOCR$ = this.bolocrService.orderBOLOCR$;
    this.orderSubscription = this.orderBOLOCR$.subscribe((orderBOLOCR) => {
      this.bolNumberFound =
        orderBOLOCR?.ocrDataLocations?.find(
          (location) => location.locationValueTypeCode === this.BOL_NUMBER_LOCATION_TYPE,
        )?.locationValue?.length > 0;

      this.poNumberFound =
        orderBOLOCR?.ocrDataLocations?.find(
          (location) => location.locationValueTypeCode === this.PURCHASE_ORDER_LOCATION_TYPE,
        )?.locationValue?.length > 0;

      this.dateFound =
        orderBOLOCR?.ocrDataLocations?.find((location) => location.locationValueTypeCode === this.DATE_LOCATION_TYPE)
          ?.locationValue?.length > 0;

      this.loadWeightFound =
        orderBOLOCR?.ocrDataLocations?.find(
          (location) => location.locationValueTypeCode === this.LOAD_WEIGHT_LOCATION_TYPE,
        )?.locationValue?.length > 0;

      this.cd.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    this.orderSubscription?.unsubscribe();
  }
}
